import React from 'react';

function DownloadFile() {
  const handleDownload = () => {
    try {
      const link = document.createElement('a');

      link.href = '/assets/files/통합제안서_Download.pdf'; 
      link.target = '_blank';
      link.download = '통합제안서_Download.pdf';
      link.click();
      
    } catch (error) {
      console.error('파일 다운로드 중 에러가 발생하였습니다', error);
    }
  };
  
  return (
    <button className="btn btn-grid" onClick={handleDownload}>
      pdf 다운로드
    </button>
  );
}

export default DownloadFile;
